<template>
  <b-col cols="12">
    <GenericTable
      id="tab_liste_reglements"
      ref="genericTable"
      :colonnes="cols"
      :endpoint-url="endpoint"
      :filterable-col="filterableCol"
      :display-archive-checkbox="false"
      no-checkbox
      @row-click="openDetails"
    />
    <LibraireModal />
  </b-col>
</template>

<script>
import GenericTable from "@/components/generics/genericTable/GenericTable.vue";
import LibraireModal from "@/components/libraires/LibraireModal.vue";

import { moneyFilter } from "@/modules/filters";

export default {
  name: "ListeReglements",
  components: { GenericTable, LibraireModal },
  data() {
    return {
      cols: [
        { key: "numero", defaultOrder: true },
        { key: "facture__numero", overrideName: "Facture" },
        { key: "facture__commande__numero", overrideName: "Commande" },
        { key: "facture__libraire__nom", overrideName: "Libraire" },
        { key: "montant_euros" },
        { key: "frais_banque" },
        { key: "mode_paiement" },
        { key: "commentaire" },
      ],
      filterableCol: [
        "numero",
        { key: "facture__numero", verbose: "facture (numéro)" },
        { key: "facture__commande__numero", verbose: "commande (numéro)" },
        { key: "facture__libraire__nom", verbose: "libraire (nom)" },
      ],
      endpoint: "/reglement",
    };
  },
  mounted() {
    this.$store.commit(
      `${this.$route.name}/setFormatDataFunction`,
      this.verboseColsReglementsForTable,
    );
  },
  methods: {
    /**
     * Affiche la modale du libraire avec les détails du règlement et de la facture associée.
     * @public
     * @param {Object} reglement Commande sélectionnée.
     */
    openDetails(reglement) {
      this.$modal.show("libraire", {
        reglement,
        libraire: reglement.facture.libraire,
      });
    },
    /**
     * Met en forme les données des tableaux des règlements.
     * @public
     * @param {Object} data Données du tableau.
     */
    verboseColsReglementsForTable(data) {
      const { results } = data;
      results.forEach((ligne) => {
        ligne.frais_banque_verbose = moneyFilter(ligne.frais_banque);
        ligne.montant_euros = moneyFilter(ligne.montant_euros);
      });
    },
  },
};
</script>

<style lang="scss">
#tab_liste_reglements {
  .numero,
  .facture__numero,
  .facture__commande__numero { width: 170px; }

  .facture__libraire__nom { width: 200px; }

  .montant,
  .frais_banque { width: 150px; }

  .mode_paiement { width: 160px; }

  .commentaire { min-width: 300px; }
}
</style>
